/**
 * @module app.core
 */

import { autoinject, bindable, bindingMode } from "aurelia-framework";
import { ICustomEditModel } from "./custom-edit";
import { ICustomFieldDefinition, ICustomFieldChoice, ICustomFieldDefinitionContainer, ICustomFieldDefinitionsLookupCollectionIndexer } from "../interfaces";

@autoinject
export class CustomEditLookup {

    @bindable({ defaultBindingMode: bindingMode.twoWay })
    public value: ICustomFieldChoice | null = null;

    @bindable({ defaultBindingMode: bindingMode.oneWay })
    public choices: ICustomFieldChoice[] = [];

    @bindable({ defaultBindingMode: bindingMode.oneWay })
    public container: ICustomFieldDefinitionContainer | null = null;

    @bindable({ defaultBindingMode: bindingMode.oneWay })
    public definition: ICustomFieldDefinition | null = null;

    constructor() { }

    protected async activate(model: ICustomEditModel): Promise<void> {
        if(model) {
            this.container = model.container;
            this.definition = model.definition;
            this.choices = model.definition.choices || [];

            const lookups = (this.container.lookup || null) as ICustomFieldDefinitionsLookupCollectionIndexer | null;
            if(lookups && this.definition.property && this.definition.property.field) {
                this.value = lookups[this.definition.property.field] || null;
            }
        }
    }

    protected valueChanged() {
        if(this.container && this.definition && this.definition.property && this.definition.property.type && this.definition.property.field) {
            const lookups = (this.container.lookup || null) as ICustomFieldDefinitionsLookupCollectionIndexer | null;
            if(lookups) {
                if(this.value && this.value.id) {
                    lookups[this.definition.property.field] = { ... this.value };
                }
                else {
                    lookups[this.definition.property.field] = null;
                }
            }
        }
    }

}
